<template>
  <main id="page" class="login">
    <b-container>
      <b-row>
        <b-col md="6" offset-md="3">
          <div class="login-panel">
            <div class="login-logo">
              <b-link :to="{name: 'home'}">
                <logo size="sm"></logo>
              </b-link>
            </div>
            <p class="text-center">
              <strong>Please enter your email address to reset your password</strong>
            </p>
            <auth-forgot-password-form/>
            <div class="login-footer-actions">
              <b-row>
                <b-col sm="6">
                  <b-button variant="outline-primary" block size="sm" :to="{name: 'login'}">Login</b-button>
                </b-col>
                <b-col sm="6">
                  <b-button variant="outline-primary" block size="sm" :href="applyUrl">
                    Apply for Membership
                  </b-button>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </main>
</template>

<script>
export default {
  data() {
    return {
      applyUrl: `${process.env.MIX_USER_APP_URL}/auth/apply`
    }
  }
}
</script>
